import React from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { useAbTestServiceInfoModal } from '@hooks';
import { ReactFCV } from '@types';
import { formatUrl } from '@utils/text';

import { useCartPageContext } from '../../context';

import { EcoPackagingService } from './EcoPackagingService';
import { FundRaisingService } from './FundRaisingService';
import { GiftPackagingService } from './GiftPackagingService';
import { InsuranceService } from './InsuranceService';
import { StyledServicesWrapper } from './styled';

export const ServiceWrapper: ReactFCV<IBasicStyledProps> = ({ ...rest }) => {
  const {
    state: {
      serviceItems: { ecoPackaging, giftPackagings, insurance, fundRaising, discoveryBox },
    },
    actions: { removeGiftPackaging, toggleEcoPackaging, toggleInsurance, setCartPageState, toggleFundRaising },
    settings: {
      giftPackaging: { giftPackagingTypes, giftPackagingOn },
      giftPackagingPrice,
      ecoPackagingPrice,
      insurancePrice,
      fundRaising: fundRaisingSettings,
      ecoPackagingEnabled,
      insuranceEnabled,
      giftPackagingLinkUrl,
    },
  } = useCartPageContext();

  const {
    applicationSettings: { secondaryCurrency },
  } = useApplicationRuntimeContext();
  const {
    settings: { websiteHostAddress },
  } = useApplicationBuildContext();

  const isDualPriceLayout = Boolean(secondaryCurrency);
  const { showServiceInfoModal } = useAbTestServiceInfoModal();
  return (
    <StyledServicesWrapper fluid={true} {...rest}>
      <GiftPackagingService
        giftPackagingBoxes={giftPackagings}
        giftPackagingOn={giftPackagingOn}
        giftPackagingTypes={giftPackagingTypes}
        giftPackagingPrice={giftPackagingPrice}
        ecoPackaging={ecoPackaging}
        removeGiftPackaging={removeGiftPackaging}
        setCartPageState={setCartPageState}
        isDualPriceLayout={isDualPriceLayout}
        giftPackagingDetailLink={formatUrl({ urlBase: websiteHostAddress, path: giftPackagingLinkUrl })}
        showServiceInfoModal={showServiceInfoModal}
      />

      <EcoPackagingService
        ecoPackagingOn={ecoPackagingEnabled}
        ecoPackaging={ecoPackaging}
        ecoPackagingPrice={ecoPackagingPrice}
        giftPackagingBoxes={giftPackagings}
        discoveryBoxes={discoveryBox}
        toggleEcoPackaging={toggleEcoPackaging}
        isDualPriceLayout={isDualPriceLayout}
      />

      <InsuranceService
        insurance={insurance}
        insuranceEnabled={insuranceEnabled}
        insurancePrice={insurancePrice}
        toggleInsurance={toggleInsurance}
        isDualPriceLayout={isDualPriceLayout}
        showServiceInfoModal={showServiceInfoModal}
      />

      <FundRaisingService
        settings={fundRaisingSettings}
        onClick={toggleFundRaising}
        fundRaisingService={fundRaising}
        isDualPriceLayout={isDualPriceLayout}
      />
    </StyledServicesWrapper>
  );
};
